import { getMissionVisionRequest } from "../repositories/mission_vision_repository";
export const MissionVisionService = () => {
    const fetchMissionVision = async (setMissionVisionData) => {
        try {
            const response = await getMissionVisionRequest();
            if (response?.success) {
                setMissionVisionData(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch mission vision data.");
        }
    };
    return {
        fetchMissionVision,
    };
};